import PilotAvailableInboxesAPI from 'dashboard/api/pilot/availableInboxes';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PilotAvailableInbox',
  API: PilotAvailableInboxesAPI,
});
